import {CalculatorRouteMetaDataModel} from "./calculator-route.meta-data.model";
import {BaseRouteConfig} from "../../../core/components/router/models/base-route-config";
import {ROUTE_NAMES} from "../../../core/consts";
import {ReactLazyPreload} from "../../../core/components/router/react-lazy-preload";

export class CalculatorRouteConfig extends BaseRouteConfig {
  static injectables = [];

  constructor(props) {
    super(props);

    this.name = ROUTE_NAMES.calculator;
    this.path = `/calculator`;
    this.component = ReactLazyPreload(() => import("../components/calculator-container" /* webpackChunkName: "calculator-container" */ ));
    this.metadataType = CalculatorRouteMetaDataModel;
  }
}
